const en = {
  nav: {
    services: "Services", whyUs: "Why Us", analytics: "Analytics", testimonials: "Testimonials",
    faq: "FAQ", resources: "Resources", contact: "Contact", book: "Book a Consultation", switchTo: "中文",
  },
  resources: {
    overline: "Client resources",
    h1a: "Guides & forms to make", h1accent: "working with us", h1b: "simple.",
    sub: "Step-by-step guides and forms we share with clients. Each one is bilingual and written so you can complete it without calling us — though you're always welcome to.",
    open: "Open guide",
    comingSoon: "More resources coming soon",
    comingSoonSub: "We're adding onboarding checklists, BAS preparation guides and record-keeping templates. Need something specific now? Just ask.",
    items: [
      {
        tag: "Interactive guide",
        title: "ATO Agent Nomination",
        desc: "How to nominate Standard Accounting & Tax Advisory as the registered tax agent for your company or trust — by phone or online through ATO Online services for business, with annotated screenshots.",
        meta: "Approx. 10 minutes · Companies & trusts",
      },
      {
        tag: "Online form",
        title: "Client Authorisation Form",
        desc: "Authorise Standard Accounting & Tax Advisory to act on your behalf with the ATO and ASIC. Bilingual, signed online, with secure ID upload — takes about 5 minutes.",
        meta: "Approx. 5 minutes · Individuals & entities",
        cta: "Open form",
      },
      {
        tag: "Online form",
        title: "Investment Property Checklist",
        desc: "Everything we need for your rental property this financial year — income, expenses, loan interest, depreciation and purchase/sale details — in one guided checklist with document upload.",
        meta: "Approx. 10 minutes · Property investors",
        cta: "Open form",
      },
      {
        tag: "Online form",
        title: "Individual Tax Return Checklist",
        desc: "Income, deductions and offsets we need to prepare your personal tax return — work-related expenses, donations, private health, investments and more — with document upload.",
        meta: "Approx. 10 minutes · Individuals",
        cta: "Open form",
      },
    ],
  },
  forms: {
    "client-authorisation": {
      overline: "Client onboarding",
      h1: "Client Authorisation Form",
      sub: "This form gives us the authority to access the ATO Tax Agent Portal and ASIC on your behalf, so we can lodge and manage your tax affairs. Complete and sign it online — we receive it instantly.",
      points: ["About 5 minutes to complete", "Encrypted submission; ID documents stored securely for KYC only", "Signed electronically — no printing or scanning"],
      back: "Back to resources",
      fallback: "Form not loading?",
      fallbackLink: "Open it in a new tab →",
    },
    "investment-property": {
      overline: "Tax return preparation",
      h1: "Investment Property Checklist",
      sub: "Use this checklist to send us the rental income, expenses and loan details for each investment property. Upload statements and receipts as you go — we'll prepare the rental schedule and maximise your deductions.",
      points: ["About 10 minutes per property", "Upload agent statements, rates, insurance and loan summaries directly", "Save time at tax time — nothing gets missed"],
      back: "Back to resources",
      fallback: "Form not loading?",
      fallbackLink: "Open it in a new tab →",
    },
    "individual-tax-return": {
      overline: "Tax return preparation",
      h1: "Individual Tax Return Checklist",
      sub: "Walk through this checklist before your personal tax return so we capture every income source and every deduction you're entitled to. Upload receipts and statements as you go — then leave the rest to us.",
      points: ["About 10 minutes to complete", "Covers work-related expenses, donations, health cover, investments and offsets", "Upload receipts directly — no need to email them separately"],
      back: "Back to resources",
      fallback: "Form not loading?",
      fallbackLink: "Open it in a new tab →",
    },
  },
  hero: {
    overline: "Boutique Advisory · Box Hill · Melbourne",
    h1a: "Confident decisions begin with", h1accent: "expert", h1b: "tax & accounting advice.",
    sub: "Standard Accounting & Tax Advisory partners with individuals, professionals, SMEs, investors and expatriates across Melbourne — delivering tailored tax planning, accurate compliance, and long-term financial clarity.",
    cta: "Book a Consultation", cta2: "Explore Services",
    trust: ["Registered Tax Agents", "Box Hill, VIC — Servicing Greater Melbourne", "20+ Years Combined Experience"],
    glance: "At a glance",
    stats: [["Average client retention", "9+ yrs"], ["Specialisations", "6 services"], ["Response time", "Within 1 business day"], ["Free initial consultation", "30 minutes"]],
    glanceNote: "A discreet, fixed-fee advisory built around your goals — not a generic high-street accountant.",
  },
  clients: { overline: "Trusted by businesses across Melbourne and beyond" },
  about: {
    overline: "About the practice",
    h2a: "A boutique advisory built on", h2accent: "precision", h2b: ", discretion and long-term partnership.",
    p1: "Based in Box Hill and trusted across Greater Melbourne, Standard Accounting & Tax Advisory delivers integrated tax planning, compliance, and business advisory work for clients who expect more than a transactional accountant.",
    p2: "We invest the time to understand your circumstances — personal, commercial, and cross-border — and structure advice that holds up under scrutiny from the ATO, lenders, and future buyers.",
    stats: [{ v: "20+", k: "Years combined experience" }, { v: "2000+", k: "Clients across Melbourne" }, { v: "6", k: "Specialised practice areas" }, { v: "9/10", k: "Repeat client engagement" }],
  },
  services: {
    overline: "Our services",
    h2a: "Specialised tax & accounting solutions for", h2accent: "every life stage", h2b: ".",
    sub: "Whether you're navigating a property sale, scaling an SME, or relocating across borders — our work is shaped around your goals, not generic templates.",
    discuss: "Discuss with an advisor →",
    ctaTitle: "Not sure which service fits your situation?",
    ctaSub: "Start with a complimentary 30-minute conversation. We'll listen, ask the right questions and tell you plainly what we'd recommend.",
    ctaBtn: "Book a free consultation",
    backHome: "Back to home",
    items: [
      { title: "Tax Planning", blurb: "Forward-looking strategies to legitimately reduce tax exposure across income, investments, and entity structures." },
      { title: "Personal Tax Returns", blurb: "Accurate, fully-deducted individual returns — including investment property, share portfolios, and side businesses." },
      { title: "Capital Gains Tax Advice", blurb: "Pre-sale CGT modelling, main-residence and small-business concessions, rollovers and disposal timing." },
      { title: "Business Consulting", blurb: "Cashflow forecasting, structuring, succession, and growth advisory tailored for owner-operated businesses." },
      { title: "SME Accounting Support", blurb: "BAS, payroll, Single Touch Payroll, bookkeeping oversight and management reporting for SMEs." },
      { title: "Integrated Tax & Accounting", blurb: "One trusted team across compliance, advisory and tax planning — joined-up advice without silos." },
    ],
  },
  why: {
    overline: "Why choose us",
    h2a: "Built for clients who expect", h2accent: "considered", h2b: "advice.",
    sub: "We're a small, senior team by design. You'll work directly with the advisor handling your file — and the answers you receive will reflect that.",
    items: [
      { title: "Deep technical expertise", body: "Registered Tax Agents with hands-on experience across personal, SME, and cross-border taxation — your file is reviewed by senior advisors, not handed off." },
      { title: "Tailored, not templated", body: "Every engagement starts with understanding your circumstances and goals. Advice is structured to your situation — not pulled from a checklist." },
      { title: "Accuracy you can defend", body: "Meticulous workpapers, ATO-ready documentation and second-pair review on every return. Confidence in audits, lender reviews and due-diligence." },
      { title: "Long-term partnership", body: "We measure success in years and decades. Many of our clients have stayed with us through career changes, business sales, and generational handovers." },
    ],
  },
  analytics: {
    overline: "Signature capability",
    h2a: "Business data consolidation &", h2accent: "analytics", h2b: "that actually drives decisions.",
    sub: "We go far beyond compliance. Using Power BI and modern data tooling, we consolidate multi-entity financials, surface margin leaks, flag pricing outliers, and turn raw inventory movements into decisions you can act on this week — not next quarter.",
    bullets: [
      "Multi-entity consolidation across branches, companies and trusts",
      "Live margin analysis by product, region, and channel",
      "Inventory run-rate — flags excess stock and stockouts",
      "Price & cost reasonableness testing at SKU level",
    ],
    cta: "Discuss your data",
    win: { consolidated: "Group Revenue & Profit Margin", inventory: "Stock Health Monitor", kpi: "Advisory Dashboard · Key Numbers" },
    chart: { title: "Monthly Revenue by Branch & Gross Margin %", sub: "Three branches consolidated into one view · illustrative data", range: "Jan – Aug", margin: "Gross margin %", revenue: "revenue" },
    inv: {
      title: "Stock Health Monitor", sub: "Which products are selling, over-stocked, or about to run out · illustrative data", tag: "updates daily",
      cols: ["Code", "Product", "Category", "Sold · 30 days", "Sold · 90 days", "Avg / month", "Stock status"],
      status: { healthy: "Healthy", excess: "Excess", short: "Stockout risk" },
      legend: ["Healthy", "Excess capital tied up", "Stockout risk"],
    },
    kpi: {
      title: "Advisory Dashboard", sub: "One page your accountant reviews with you each month · illustrative data", tag: "this month",
      items: [
        { label: "Average gross margin", v: "36.4%", delta: "+2.1pp vs last quarter" },
        { label: "Branches consolidated", v: "3", delta: "Melbourne · Sydney · Brisbane" },
        { label: "Cash tied up in excess stock", v: "$412K", delta: "-8.4% this month" },
        { label: "Products at stockout risk", v: "17", delta: "-6 vs last month" },
        { label: "Pricing outliers flagged", v: "24", delta: "avg 11% below list" },
        { label: "Cost anomalies reviewed", v: "9", delta: "all resolved" },
      ],
      insightLabel: "Advisor insight →",
      insight: "Sydney branch margin slipped 2.4 points this month, driven by heavy discounting on Lighting. Recommend tightening the promo budget by 1.2% next cycle.",
    },
  },
  testimonials: {
    overline: "Real client outcomes",
    h2a: "Real problems, real results —", h2accent: "in our clients' words", h2b: ".",
    disclaimer: "Stock photo, not the actual client — feedback reflects a real engagement.",
    items: [
      { quote: "Patient, hands-on and genuinely good with technology. They got our shops and Xero working together when I couldn't, and it's given me and my staff our time back. They go well beyond what I expected from an accountant.", name: "Sophie N.", role: "Owner · Bottle shop chain, Kew" },
      { quote: "Selling my old home from overseas, I'd already accepted I would lose a big chunk to tax. They found a way I never knew existed and fought for it with the ATO. I can't thank them enough.", name: "Grace L.", role: "Former Melbourne resident · Now living overseas" },
      { quote: "Our books were a mess and I was flying blind. Within a few weeks they had everything running smoothly and I finally knew where the business actually stood. They feel like part of our team now.", name: "David C.", role: "Managing Director · Melbourne SME" },
    ],
  },
  booking: {
    overline: "Book a consultation",
    h2a: "A 30-minute conversation that", h2accent: "often pays for itself", h2b: ".",
    sub: "Tell us briefly what you're working through. A senior advisor will respond within one business day with a clear next step — no obligation.",
    points: ["Reply within 1 business day", "Confidential, ATO-aligned advice", "Fixed-fee scope before any engagement"],
    prefer: "Prefer to talk?", hours: "Mon–Fri, 8:00am – 6:00pm AEST",
    name: "Full name", email: "Email", phone: "Phone", service: "Service needed", servicePh: "Select a service",
    message: "How can we help?", optional: "(optional)",
    messagePh: "A brief note about your situation — investments, business stage, expat status, etc.",
    submit: "Request my consultation", sending: "Sending…",
    consent: "By submitting, you agree to be contacted about your enquiry. Your details are kept confidential and never shared.",
    successTitle: "Request received",
    successBody: "Thank you for reaching out. A confirmation has been sent to your email, and a senior advisor will be in touch within one business day.",
    another: "Submit another request",
    toastOk: "Consultation request received", toastOkDesc: "We'll be in touch within one business day.",
    toastErr: "Could not submit", toastErrDesc: "Please try again or call us directly.",
    errName: "Please enter your name", errEmail: "Enter a valid email", errPhone: "Enter a valid phone", errService: "Choose a service",
    options: ["Tax Planning", "Personal Tax Return", "Capital Gains Tax Advice", "Business Consulting", "SME Accounting Support", "Integrated Tax & Accounting", "Something Else"],
  },
  faq: {
    overline: "Frequently asked",
    h2a: "Answers to common", h2accent: "tax & accounting", h2b: "questions.",
    sub: "Have something specific in mind? Mention it in your booking — we'll address it in the first call.",
    items: [
      { q: "What should I actually expect from my accountant during the year — not just at tax time?", a: "More than tax returns and reminders. Our job is to give you clarity: to explain what your numbers mean, flag issues early, and tell you what we think you should do next. We won't sit and wait for instructions. We work closely with you and your team — and where we see a better way forward, we'll say so." },
      { q: "My books are a mess and I'm behind with the ATO. Can you still help me?", a: "Yes — and you don't need to have everything tidy before you call. We regularly help businesses clean up their bookkeeping, catch up on overdue BAS and tax returns, reconcile historical accounts, and work out what genuinely needs fixing first. Step one is simply understanding where things stand and putting a clear plan in place." },
      { q: "Can you help reduce Capital Gains Tax on a property or share sale?", a: "Often, yes — through timing, ownership structure, main-residence exemptions, small-business CGT concessions, and contribution strategies. The biggest savings come from planning before the sale settles." },
      { q: "Do you handle business and personal tax together?", a: "Yes. Our integrated model means one team manages your individual return, business compliance, and tax planning — so nothing is missed across structures." },
      { q: "What does an initial consultation cost?", a: "The initial 30-minute consultation is complimentary. If you decide to engage us, you'll receive a fixed-fee scope before any work begins — no surprises." },
      { q: "Where are you located, and do you work with clients outside Box Hill?", a: "Our office is in Box Hill, Victoria, but we work with clients across Greater Melbourne and remotely Australia-wide. Most documents and meetings can be handled securely online." },
    ],
  },
  footer: {
    ready: "Ready when you are",
    cta: "Let's structure your tax and accounting with the clarity you deserve.",
    ctaBtn: "Book a Consultation",
    blurb: "A boutique accounting and tax advisory firm in Box Hill, serving individuals, SMEs, professionals, investors and expatriates across Melbourne.",
    contact: "Contact", quick: "Quick links", services: "Services",
    address1: "Suite 512, 830 Whitehorse Road", address2: "Box Hill, VIC 3128",
    hours: "Mon–Fri, 8:00am – 6:00pm AEST",
    quickLinks: ["Services", "Why Us", "Testimonials", "Book a Consultation", "FAQ", "Resources"],
    serviceLinks: ["Tax Planning", "Personal Tax Returns", "Capital Gains Tax Advice", "Business Consulting", "SME Accounting Support", "Integrated Tax & Accounting"],
    rights: "Standard Accounting & Tax Advisory. All rights reserved.",
    tagline: "Registered Tax Agents · Box Hill · Melbourne",
  },
};

const zh = {
  nav: {
    services: "服务", whyUs: "为何选择我们", analytics: "数据分析", testimonials: "客户评价",
    faq: "常见问题", resources: "资源", contact: "联系我们", book: "预约咨询", switchTo: "EN",
  },
  resources: {
    overline: "客户资源",
    h1a: "让", h1accent: "与我们合作", h1b: "更简单的指南与表格。",
    sub: "我们与客户分享的分步指南和表格，均为中英双语，按说明即可自行完成——当然，随时欢迎联系我们。",
    open: "打开指南",
    comingSoon: "更多资源即将上线",
    comingSoonSub: "我们正在添加新客户入门清单、BAS 准备指南和记账模板。现在就需要某份资料？直接告诉我们。",
    items: [
      {
        tag: "互动指南",
        title: "ATO 税务代理授权（Agent Nomination）",
        desc: "如何在 ATO 将 Standard Accounting & Tax Advisory 提名为您公司或信托的注册税务代理——可电话办理，也可通过 ATO 企业网上服务在线完成，附带标注截图。",
        meta: "约 10 分钟 · 适用于公司与信托",
      },
      {
        tag: "在线表格",
        title: "客户授权表（Client Authorisation Form）",
        desc: "授权 Standard Accounting & Tax Advisory 代表您处理 ATO 与 ASIC 事务。中英双语、在线签名、安全上传身份证件——约 5 分钟完成。",
        meta: "约 5 分钟 · 适用于个人与实体",
        cta: "填写表格",
      },
      {
        tag: "在线表格",
        title: "财年投资房所需材料清单",
        desc: "本财年出租房报税所需的全部信息——租金收入、各项支出、贷款利息、折旧及买卖详情——一份引导式清单，支持直接上传文件。",
        meta: "约 10 分钟 · 适用于房产投资者",
        cta: "填写表格",
      },
      {
        tag: "在线表格",
        title: "财年个人报税所需材料清单",
        desc: "准备个人退税所需的收入、抵扣与减免信息——工作相关支出、捐款、私人医保、投资收益等——支持直接上传凭证。",
        meta: "约 10 分钟 · 适用于个人",
        cta: "填写表格",
      },
    ],
  },
  forms: {
    "client-authorisation": {
      overline: "新客户入门",
      h1: "客户授权表",
      sub: "本表格授权我们代表您访问 ATO 税务代理门户及 ASIC，以便为您申报并处理税务事宜。在线填写并签名——我们会即时收到。",
      points: ["约 5 分钟即可完成", "加密提交；身份证件仅用于 KYC 合规并安全存储", "电子签名——无需打印或扫描"],
      back: "返回资源页",
      fallback: "表格无法加载？",
      fallbackLink: "在新标签页打开 →",
    },
    "investment-property": {
      overline: "报税资料准备",
      h1: "财年投资房所需材料清单",
      sub: "请通过此清单向我们提供每套投资房的租金收入、支出及贷款信息，并随手上传对账单和收据——我们将为您编制租赁明细表，并争取最大化抵扣。",
      points: ["每套房产约 10 分钟", "可直接上传中介对账单、市政费、保险及贷款年度汇总", "报税季省时省心——不漏掉任何一项"],
      back: "返回资源页",
      fallback: "表格无法加载？",
      fallbackLink: "在新标签页打开 →",
    },
    "individual-tax-return": {
      overline: "报税资料准备",
      h1: "财年个人报税所需材料清单",
      sub: "报个人税前请先过一遍这份清单，确保我们掌握您的每一项收入来源和每一笔应得抵扣。随手上传收据和对账单——其余交给我们。",
      points: ["约 10 分钟即可完成", "涵盖工作相关支出、捐款、医保、投资收益及各类减免", "凭证直接上传——无需另行发邮件"],
      back: "返回资源页",
      fallback: "表格无法加载？",
      fallbackLink: "在新标签页打开 →",
    },
  },
  hero: {
    overline: "精品会计事务所 · Box Hill · 墨尔本",
    h1a: "明智的决策，始于", h1accent: "专业", h1b: "的税务与会计建议。",
    sub: "标准会计事务所（Standard Accounting & Tax Advisory）服务于墨尔本的个人、专业人士、中小企业、投资者及海外华人——提供量身定制的税务规划、精准合规申报与长期财务清晰度。",
    cta: "预约咨询", cta2: "了解服务",
    trust: ["注册税务代理", "Box Hill, VIC — 服务大墨尔本地区", "20年以上综合经验"],
    glance: "一览",
    stats: [["客户平均合作年限", "9年以上"], ["专业领域", "6 项服务"], ["响应时间", "1 个工作日内"], ["首次免费咨询", "30 分钟"]],
    glanceNote: "围绕您的目标量身打造的固定收费顾问服务——而非千篇一律的街边会计。",
  },
  clients: { overline: "深受墨尔本及各地企业信赖" },
  about: {
    overline: "关于我们",
    h2a: "以", h2accent: "精准", h2b: "、审慎与长期合作为基石的精品会计事务所。",
    p1: "我们位于 Box Hill，深受大墨尔本地区客户信赖，为期待超越流水线式服务的客户提供税务规划、合规申报与商业咨询一体化服务。",
    p2: "我们愿意花时间了解您的个人、商业及跨境情况，为您搭建经得起澳洲税务局（ATO）、贷款机构及未来买家审视的税务方案。",
    stats: [{ v: "20+", k: "年综合经验" }, { v: "2000+", k: "墨尔本客户" }, { v: "6", k: "专业执业领域" }, { v: "9/10", k: "客户持续合作率" }],
  },
  services: {
    overline: "我们的服务",
    h2a: "为", h2accent: "人生每个阶段", h2b: "提供专业的税务与会计解决方案。",
    sub: "无论您正在出售房产、扩大企业规模，还是跨境迁居——我们的工作都围绕您的目标展开，而非套用模板。",
    discuss: "与顾问详谈 →",
    ctaTitle: "不确定哪项服务适合您？",
    ctaSub: "从一次 30 分钟的免费交谈开始。我们会认真倾听、问对问题，并坦率地告诉您我们的建议。",
    ctaBtn: "预约免费咨询",
    backHome: "返回首页",
    items: [
      { title: "税务规划", blurb: "前瞻性策略，合法降低收入、投资及实体架构层面的税务负担。" },
      { title: "个人报税", blurb: "精准、应扣尽扣的个人退税——涵盖投资房、股票组合及副业收入。" },
      { title: "资本增值税（CGT）建议", blurb: "售前 CGT 测算、自住房及小型企业优惠、递延与出售时机安排。" },
      { title: "商业咨询", blurb: "为业主自营企业定制的现金流预测、架构搭建、传承与增长咨询。" },
      { title: "中小企业会计支持", blurb: "BAS、工资、STP 单触式工资申报、账务监督及管理报表。" },
      { title: "税务与会计一体化", blurb: "一支值得信赖的团队，贯通合规、咨询与税务规划——无缝衔接，不留盲区。" },
    ],
  },
  why: {
    overline: "为何选择我们",
    h2a: "为期待", h2accent: "深思熟虑", h2b: "建议的客户而生。",
    sub: "我们刻意保持小而精的资深团队。您将直接与负责您档案的顾问沟通——得到的答案也会体现这一点。",
    items: [
      { title: "深厚的专业功底", body: "注册税务代理，在个人、中小企业及跨境税务领域拥有丰富实战经验——您的档案由资深顾问亲自审阅，绝不转手。" },
      { title: "量身定制，而非套用模板", body: "每一次合作都从了解您的情况与目标开始。建议根据您的实际情况构建——而非照搬清单。" },
      { title: "经得起检验的精准", body: "细致的工作底稿、符合 ATO 要求的文件及每份申报的双人复核。面对审计、贷款审查与尽职调查，从容自信。" },
      { title: "长期合作伙伴", body: "我们以年、以十年计衡量成功。许多客户在职业转换、企业出售乃至代际传承中始终与我们同行。" },
    ],
  },
  analytics: {
    overline: "拳头能力",
    h2a: "生意数据整合与分析，", h2accent: "真正驱动决策", h2b: "。",
    sub: "我们远不止于合规。借助 Power BI 与现代数据工具，我们整合多实体财务数据、发现利润漏洞、标记异常定价，并将原始库存流水转化为本周即可执行的决策——而非等到下个季度。",
    bullets: [
      "跨分店、公司与信托的多实体数据整合",
      "按产品、地区、渠道的实时利润率分析",
      "库存动销率——自动标记积压与断货风险",
      "SKU 级别的价格与成本合理性检测",
    ],
    cta: "聊聊您的数据",
    win: { consolidated: "集团营收与利润率", inventory: "库存健康监控", kpi: "顾问看板 · 关键指标" },
    chart: { title: "各分店月度营收 & 毛利率 %", sub: "三家分店合并为一个视图 · 示意数据", range: "1月 – 8月", margin: "毛利率 %", revenue: "营收" },
    inv: {
      title: "库存健康监控", sub: "哪些产品畅销、积压或即将断货 · 示意数据", tag: "每日更新",
      cols: ["编码", "产品", "类别", "30天销量", "90天销量", "月均", "库存状态"],
      status: { healthy: "健康", excess: "积压", short: "断货风险" },
      legend: ["健康", "资金积压", "断货风险"],
    },
    kpi: {
      title: "顾问看板", sub: "会计师每月与您一起复盘的一页纸 · 示意数据", tag: "本月",
      items: [
        { label: "平均毛利率", v: "36.4%", delta: "较上季度 +2.1 个百分点" },
        { label: "合并分店数", v: "3", delta: "墨尔本 · 悉尼 · 布里斯班" },
        { label: "积压库存占用资金", v: "$412K", delta: "本月 -8.4%" },
        { label: "断货风险产品数", v: "17", delta: "较上月 -6" },
        { label: "标记的异常定价", v: "24", delta: "平均低于标价 11%" },
        { label: "已复核成本异常", v: "9", delta: "全部处理完毕" },
      ],
      insightLabel: "顾问洞察 →",
      insight: "悉尼分店本月毛利率下滑 2.4 个百分点，主因灯具类大幅折扣。建议下一周期收紧促销预算 1.2%。",
    },
  },
  testimonials: {
    overline: "真实客户成果",
    h2a: "真实的问题，真实的结果 ——", h2accent: "来自客户的声音", h2b: "。",
    disclaimer: "照片为示意图，非客户本人——反馈来自真实合作案例。",
    items: [
      { quote: "耐心、亲力亲为，而且真的懂技术。我自己搞不定，他们把我们几家店和 Xero 打通了，让我和员工都省下了大量时间。他们做的远远超出了我对会计的期待。", name: "Sophie N.", role: "业主 · 连锁酒行，Kew" },
      { quote: "人在海外卖掉墨尔本的旧房子，我已经做好了被税掉一大块的准备。他们找到了一条我从未听过的路，并且为我和 ATO 争取到了。真的万分感谢。", name: "Grace L.", role: "前墨尔本居民 · 现居海外" },
      { quote: "我们的账目一团糟，我完全是在盲飞。几周之内他们就把一切理顺了，我终于知道公司的真实状况。现在他们就像我们团队的一部分。", name: "David C.", role: "总经理 · 墨尔本中小企业" },
    ],
  },
  booking: {
    overline: "预约咨询",
    h2a: "一次 30 分钟的交谈，", h2accent: "往往物超所值", h2b: "。",
    sub: "简单告诉我们您正在面对的问题。资深顾问将在 1 个工作日内回复您清晰的下一步建议——无任何义务。",
    points: ["1 个工作日内回复", "保密、符合 ATO 规范的建议", "合作前先给出固定收费范围"],
    prefer: "更想直接通话？", hours: "周一至周五 8:00am – 6:00pm（墨尔本时间）",
    wechat: "或扫码添加微信咨询",
    name: "姓名", email: "电子邮箱", phone: "电话", service: "所需服务", servicePh: "请选择服务",
    message: "我们能帮您什么？", optional: "（选填）",
    messagePh: "简要说明您的情况——投资、企业阶段、海外身份等。",
    submit: "提交咨询预约", sending: "提交中…",
    consent: "提交即表示您同意我们就此咨询与您联系。您的信息将严格保密，绝不外泄。",
    successTitle: "已收到您的预约",
    successBody: "感谢您的联系。确认邮件已发送至您的邮箱，资深顾问将在 1 个工作日内与您联系。",
    another: "再提交一份",
    toastOk: "预约已收到", toastOkDesc: "我们将在 1 个工作日内与您联系。",
    toastErr: "提交失败", toastErrDesc: "请重试或直接电话联系我们。",
    errName: "请输入您的姓名", errEmail: "请输入有效的邮箱", errPhone: "请输入有效的电话", errService: "请选择服务",
    options: ["税务规划", "个人报税", "资本增值税建议", "商业咨询", "中小企业会计支持", "税务与会计一体化", "其他"],
  },
  faq: {
    overline: "常见问题",
    h2a: "关于", h2accent: "税务与会计", h2b: "的常见问题解答。",
    sub: "有具体问题？在预约时留言告诉我们——首次通话时即为您解答。",
    items: [
      { q: "除了报税季，平时我到底能从会计师那里得到什么？", a: "远不止报税和催单提醒。我们的职责是让您看得清楚：解释数字背后的含义、及早发现问题，并主动告诉您下一步该怎么做。我们不会坐等指示。我们与您和您的团队紧密配合——一旦发现更好的做法，会直接告诉您。" },
      { q: "我的账很乱，ATO 的申报也拖欠了，你们还能帮我吗？", a: "可以——而且您不需要先把一切整理好再来找我们。我们经常帮企业清理账务、补交逾期的 BAS 和税务申报、核对历史账目，并理清真正需要优先解决的问题。第一步只是弄清现状，然后制定一份清晰的计划。" },
      { q: "出售房产或股票时能帮我降低资本增值税吗？", a: "通常可以——通过出售时机、持有架构、自住房豁免、小型企业 CGT 优惠及养老金供款策略。最大的节税空间来自交割前的规划。" },
      { q: "企业和个人税务能一起处理吗？", a: "可以。我们的一体化模式由同一团队管理您的个人申报、企业合规与税务规划——跨架构无遗漏。" },
      { q: "首次咨询收费吗？", a: "首次 30 分钟咨询免费。如您决定委托我们，在任何工作开始前都会收到固定收费范围——绝无意外。" },
      { q: "你们在哪里？Box Hill 以外的客户也服务吗？", a: "我们的办公室位于维州 Box Hill，但服务大墨尔本地区并远程覆盖全澳客户。大部分文件与会议均可安全在线完成。" },
    ],
  },
  footer: {
    ready: "随时为您服务",
    cta: "让我们以您应得的清晰度，为您规划税务与会计。",
    ctaBtn: "预约咨询",
    blurb: "位于 Box Hill 的精品会计与税务事务所，服务墨尔本的个人、中小企业、专业人士、投资者及海外华人。",
    contact: "联系方式", quick: "快速链接", services: "服务",
    address1: "Suite 512, 830 Whitehorse Road", address2: "Box Hill, VIC 3128",
    hours: "周一至周五 8:00am – 6:00pm（墨尔本时间）",
    wechat: "微信扫码咨询",
    quickLinks: ["服务", "为何选择我们", "客户评价", "预约咨询", "常见问题", "资源"],
    serviceLinks: ["税务规划", "个人报税", "资本增值税建议", "商业咨询", "中小企业会计支持", "税务与会计一体化"],
    rights: "标准会计事务所 Standard Accounting & Tax Advisory 版权所有。",
    tagline: "注册税务代理 · Box Hill · 墨尔本",
  },
};

export const translations = { en, zh };
